export default {"src":"/_next/static/media/codex.97207151.svg","height":300,"width":900};